var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog-conversation-history'),_c('dialog-block-customer'),_c('dialog-create-m-a-d-template'),_c('dialog-update-m-a-d-template'),_c('dialog-m-a-d-template'),_c('dialog-create-quick-response')],1)}
var staticRenderFns = []

export { render, staticRenderFns }